exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cart-name-cell[data-v-739d24ac]{\n  max-width: 250px;\n}\n", ""]);

// exports
